__turbopack_context__.v({
  "badge": "feature-card-module-scss-module__FEbprW__badge",
  "card": "feature-card-module-scss-module__FEbprW__card",
  "copy": "feature-card-module-scss-module__FEbprW__copy",
  "description": "feature-card-module-scss-module__FEbprW__description",
  "title": "feature-card-module-scss-module__FEbprW__title",
});
